import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
const BUYERS = [{
  name: 'Martín G.',
  city: 'Buenos Aires',
  flag: '🇦🇷',
  time: 'hace 2 min'
}, {
  name: 'Valentina R.',
  city: 'Córdoba',
  flag: '🇦🇷',
  time: 'hace 5 min'
}, {
  name: 'Lucía P.',
  city: 'Rosario',
  flag: '🇦🇷',
  time: 'hace 3 min'
}, {
  name: 'Sofía T.',
  city: 'Mendoza',
  flag: '🇦🇷',
  time: 'hace 6 min'
}, {
  name: 'Camila V.',
  city: 'Mar del Plata',
  flag: '🇦🇷',
  time: 'hace 7 min'
}, {
  name: 'Florencia N.',
  city: 'Tucumán',
  flag: '🇦🇷',
  time: 'hace 2 min'
}, {
  name: 'Nicolás B.',
  city: 'La Plata',
  flag: '🇦🇷',
  time: 'hace 4 min'
}, {
  name: 'Agustina M.',
  city: 'Salta',
  flag: '🇦🇷',
  time: 'hace 8 min'
}, {
  name: 'Facundo L.',
  city: 'San Juan',
  flag: '🇦🇷',
  time: 'hace 1 min'
}, {
  name: 'Romina C.',
  city: 'Neuquén',
  flag: '🇦🇷',
  time: 'hace 9 min'
}, {
  name: 'Ezequiel D.',
  city: 'Bahía Blanca',
  flag: '🇦🇷',
  time: 'hace 11 min'
}, {
  name: 'Micaela F.',
  city: 'Corrientes',
  flag: '🇦🇷',
  time: 'hace 3 min'
}];
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    // Show first notification after 5 seconds
    const initialTimer = setTimeout(() => {
      setVisible(true);
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    // Auto-hide after 4 seconds
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, 4000);
    return () => clearTimeout(hideTimer);
  }, [visible, currentIndex]);
  useEffect(() => {
    if (visible) return;
    // Show next notification every 20 seconds after hiding
    const nextTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % BUYERS.length);
      setVisible(true);
    }, 20000);
    return () => clearTimeout(nextTimer);
  }, [visible]);
  const buyer = BUYERS[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 max-w-xs w-full sm:max-w-sm pointer-events-none" data-id="element-372">
      <AnimatePresence data-id="element-373">
        {visible && <motion.div initial={{
        opacity: 0,
        x: -80,
        y: 10
      }} animate={{
        opacity: 1,
        x: 0,
        y: 0
      }} exit={{
        opacity: 0,
        x: -80,
        y: 10
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="pointer-events-auto bg-zinc-900 border border-zinc-700 rounded-2xl p-4 shadow-2xl shadow-black/50 flex items-center gap-3" data-id="element-374">
            {/* Icon */}
            <div className="w-11 h-11 bg-emerald-500/15 rounded-xl flex items-center justify-center flex-shrink-0 text-xl" data-id="element-375">
              {buyer.flag}
            </div>

            {/* Content */}
            <div className="flex-1 min-w-0" data-id="element-376">
              <p className="text-white text-sm font-semibold leading-tight" data-id="element-377">
                {buyer.name}{' '}
                <span className="text-zinc-400 font-normal" data-id="element-378">
                  de {buyer.city}
                </span>
              </p>
              <div className="flex items-center gap-1.5 mt-0.5" data-id="element-379">
                <ShoppingBagIcon className="w-3.5 h-3.5 text-emerald-400 flex-shrink-0" data-id="element-380" />
                <p className="text-emerald-400 text-xs font-medium" data-id="element-381">
                  acaba de comprar la guía
                </p>
              </div>
              <p className="text-zinc-600 text-xs mt-0.5" data-id="element-382">{buyer.time}</p>
            </div>

            {/* Close */}
            <button onClick={() => setVisible(false)} className="text-zinc-600 hover:text-zinc-400 transition-colors flex-shrink-0 p-1" aria-label="Cerrar" data-id="element-383">
              <XIcon className="w-4 h-4" data-id="element-384" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}